var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"measurement-layout"},[_c('HeaderMeterage'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('Courier',{ref:"courier",attrs:{"client-type":"user"}}),_vm._v(" "),_c('Courier',{ref:"courier",attrs:{"client-type":"shop"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }